<template>
  <div class="flex flex-dir-column app-layout orver-hidden-x" v-loading="queryLoading">
    <!-- 顶部搜索的表单 -->
    <div class="top-search padding-left-10 padding-right-10">
      <el-form
        align="left"
        size="mini"
        ref="topForm"
        :model="formQuery"
        label-width="0"
        :inline="true"
        class="flex flex-wrap flex-justify-start"
      >
        <el-form-item label="平台应用" label-width="70px">
          <system-select
            size="mini"
          />
        </el-form-item>
        <div class="margin-right-20">
          <Version
            :os.sync="formQuery.os"
            :osVersion.sync="formQuery.osVersion"
            @update="renderChartData"
            noShowVersionList
            isMergeVersion
          />
        </div>
        <el-form-item
          v-if="['iOS', 'Android', ''].includes(formQuery.os)"
          label="应用版本号"
          label-width="90px"
        >
          <el-input
            clearable
            v-model="formQuery.version"
            placeholder="请输入应用版本号"
            @change="renderChartData"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="formQuery.range"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            unlink-panels
            :clearable="false"
            @change="renderChartData"
            :picker-options="MonthPickerOptions"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <el-row :gutter="20" class="padding-left-20 padding-right-20 padding-bottom-20">
      <!-- 设备分布 -->
      <el-col :span="12">
        <el-card class="box-card">
          <div class="box-chart padding-top-20">
            <div class="title">设备分布</div>
            <Echart
              :height="300"
              isMountedRender
              :id="'chartDistribution'"
              :data="queryOsTop"
              :type="'pie'"
            />
          </div>
        </el-card>
      </el-col>
      <!-- 用户TOP -->
      <el-col :span="12">
        <el-card class="box-card">
          <div class="box-chart padding-top-20">
            <div class="title">TOP10机型</div>
            <Echart
              :height="300"
              isMountedRender
              :id="'chartModel'"
              :data="queryDeviceModelTop"
              :xType="'value'"
              :yType="'category'"
              :xShow="false"
              :showData="true"
              :type="'bar'"
            />
          </div>
        </el-card>
      </el-col>
      <!-- TOP10分辨率 -->
      <el-col :span="12">
        <el-card class="box-card">
          <div class="box-chart padding-top-20">
            <div class="title">TOP10分辨率</div>
            <Echart
              :height="300"
              isMountedRender
              :id="'chartResolution'"
              :data="queryScreenResolutionTop"
              :xType="'value'"
              :yType="'category'"
              :xShow="false"
              :showData="true"
              :type="'bar'"
            />
          </div>
        </el-card>
      </el-col>
      <!-- 终端系统 -->
      <el-col :span="12">
        <el-card class="box-card">
          <div class="box-chart padding-top-20">
            <div class="title">终端系统</div>
            <Echart
              :height="300"
              isMountedRender
              :id="'chartTerminal'"
              :data="queryOsInfoTop"
              :xType="'value'"
              :yType="'category'"
              :xShow="false"
              :showData="true"
              :type="'bar'"
            />
          </div>
        </el-card>
      </el-col>
      <!-- TOP10浏览器 -->
      <el-col :span="12">
        <el-card class="box-card">
          <div class="box-chart padding-top-20">
            <div class="title">TOP10浏览器</div>
            <Echart
              :height="300"
              isMountedRender
              :id="'chartBrower'"
              :data="queryBrowserNameTop"
              :xType="'value'"
              :yType="'category'"
              :xShow="false"
              :showData="true"
              :type="'bar'"
            />
          </div>
        </el-card>
      </el-col>
      <!-- 网络 -->
      <el-col :span="12">
        <el-card class="box-card">
          <div class="box-chart padding-top-20">
            <div class="title">网络</div>
            <Echart
              :height="300"
              isMountedRender
              :id="'chartNetwork'"
              :data="queryNetworkTypeTop"
              :xType="'value'"
              :yType="'category'"
              :xShow="false"
              :showData="true"
              :type="'bar'"
            />
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Moment from 'moment';
import {
  queryOsTop,
  queryDeviceModelTop,
  queryScreenResolutionTop,
  queryOsInfoTop,
  queryBrowserNameTop,
  queryNetworkTypeTop,
} from '@/api/analyze';
import { MonthPickerOptions } from '@/data/picker-options';
import Echart from '@/views/components/echart/index.vue';
import Version from '../components/version.vue';

export default {
  components: { Echart, Version },
  computed: {
    ...mapGetters('app', ['env', 'source', 'bizChannel']),
  },
  data() {
    this.dataMap = {
      // 查询设备型号top
      queryDeviceModelTop: { xValue: 'deviceModel', yValue: 'count' },
      // 查询屏幕分辨率top
      queryScreenResolutionTop: { xValue: 'screenResolution', yValue: 'count' },
      // 查询操作系统信息top
      queryOsInfoTop: { xValue: 'osInfo', yValue: 'count' },
      // 查询浏览器名称top
      queryBrowserNameTop: { xValue: 'browserName', yValue: 'count' },
      // 查询网络类型top
      queryNetworkTypeTop: { xValue: 'networkType', yValue: 'count' },
    };
    return {
      MonthPickerOptions,
      queryNetworkTypeTop: {
        x: ['暂无数据'],
        y: ['0'],
      },
      queryOsInfoTop: {
        x: ['暂无数据'],
        y: ['0'],
      },
      queryBrowserNameTop: {
        x: ['暂无数据'],
        y: ['0'],
      },
      queryScreenResolutionTop: {
        x: ['暂无数据'],
        y: ['0'],
      },
      // 查询设备型号top
      queryDeviceModelTop: {
        x: ['暂无数据'],
        y: ['0'],
      },
      queryOsTop: {
        name: '暂无数据',
        data: [
          {
            value: 0,
            name: '',
          },
        ],
      },
      formQuery: {
        range: [],
        osVersion: '',
        eventCode: '',
        os: '',
      },
      pageEvents: [],
      queryLoading: false,
    };
  },
  mounted() {
    const today = Moment().format('YYYY-MM-DD');
    const today2 = Moment().subtract(7, 'days').format('YYYY-MM-DD');
    this.formQuery.range = [new Date(today2), new Date(today)];
    this.renderChartData();
  },
  watch: {
    source: {
      handler() {
        this.renderChartData();
      },
    },
    bizChannel: {
      handler(val, old) {
        if (val !== old && this.source === '') {
          this.renderChartData();
        }
      },
    },
  },
  methods: {
    // eslint-disable-next-line default-param-last
    resetChartData(data = [], type) {
      const {
        dataMap,
      } = this;

      const {
        xValue,
        yValue,
      } = dataMap[type];

      const xList = [];
      const yList = [];
      if (!data.length) {
        xList.push('暂无数据');
        yList.push(0);
      } else {
        data.forEach((item) => {
          xList.push(item[xValue]);
          yList.push(item[yValue]);
        });
      }

      this[type].x.splice(0, this[type].x.length, ...xList);
      this[type].y.splice(0, this[type].y.length, ...yList);
    },
    // eslint-disable-next-line default-param-last
    resetPieChartData(data = [], type) {
      if (!data.length) {
        this.$set(this, type, {
          name: '暂无数据',
          data: [
            {
              value: 0,
              name: '',
            },
          ],
        });
      } else {
        const pieData = [];
        data.forEach(({ os, count }) => {
          pieData.push({
            value: count,
            name: os,
          });
        });
        this[type].name = '';

        // console.log(this[type].data, pieData);
        // this[type].data.splice(0, this[type].length, ...pieData);
        this[type].data.splice(0);
        this[type].data.push(...pieData);
      }
    },
    async queryChartData(method, params, type) {
      try {
        const { data } = await method(params);

        if (type === 'queryOsTop') {
          this.resetPieChartData(data, type);
          return;
        }

        data.reverse();
        this.resetChartData(data, type);
        // return data;
      } catch (e) {
        if (type === 'queryOsTop') {
          this.resetPieChartData([], type);
          return;
        }
        this.resetChartData([], type);
        // return [];
      }
    },
    async renderChartData() {
      this.queryLoading = true;
      try {
        const {
          range,
          osVersion,
          version,
          os,
        } = this.formQuery;
        const analyzeTimeTo = `${Moment(range[1]).format('YYYY-MM-DD')} 23:59:59`;
        const analyzeTimeFrom = `${Moment(range[0]).format('YYYY-MM-DD')} 00:00:00`;

        const params = {
          analyzeTimeTo,
          analyzeTimeFrom,
          topCount: 10,
          osVersion,
          os,
        };
        params.version = ['iOS', 'Android', ''].includes(os) ? version : '';

        this.queryChartData(queryOsTop, { ...params }, 'queryOsTop');
        this.queryChartData(queryDeviceModelTop, params, 'queryDeviceModelTop');
        this.queryChartData(queryScreenResolutionTop, params, 'queryScreenResolutionTop');
        this.queryChartData(queryOsInfoTop, params, 'queryOsInfoTop');
        this.queryChartData(queryBrowserNameTop, params, 'queryBrowserNameTop');
        this.queryChartData(queryNetworkTypeTop, params, 'queryNetworkTypeTop');
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.box-card {
  border: 0;
  text-align: left;
  margin-bottom: 20px;
  &::v-deep {
    .el-card__body {
      padding-top: 0;
    }
  }
  &-echart {
    background: transparent;
    // max-height: 400px;
    overflow: auto;
  }
}
.app-layout {
  min-width: 800px;
  margin: 15px 0 0;
}
// .top-search {
//   position: fixed;
//   top: 95px;
//   left: 15px;
//   right: 15px;
//   padding: 30px 20px 0;
//   background: #fff;
//   z-index: 99;
//   text-align: left;
//   border-radius: 5px;
// }
.box-chart {
  .title {
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 10px;
  }
}
</style>
